import debounce from 'lodash-es/debounce';

class ChatScroll {
  constructor(el, vnode) {
    this.el = el;
    this.vnode = vnode;
    this.observer = null;

    this.isLoading = false;
    this.isScrolled = false;
    this.isCompleted = false;
    this.isFirstUpdate = true;

    this.functions = {
      onScroll: debounce(this.onScroll.bind(this), 150),
      onCompleted: this.onCompleted.bind(this),
    };

    this.create();
  }

  create() {
    this.observer = new MutationObserver(e => {
      const addedNodes = e[e.length - 1].addedNodes.length;
      const removedNodes = e[e.length - 1].removedNodes.length;
      if (this.isScrolled || addedNodes !== 1 && removedNodes !== 1) return;

      this.scrollToBottom(!this.isFirstUpdate);
      if (this.isFirstUpdate) this.isFirstUpdate = false;
    });
  }

  init() {
    this.el.addEventListener('scroll', this.functions.onScroll);
    this.observer.observe(this.el, { childList: true, subtree: true });
  }

  onScroll(e) {
    this.isScrolled = this.el.scrollTop + (this.el.clientHeight * 3) < this.el.scrollHeight;

    if (e.target.scrollTop < 40 && !this.isLoading && !this.isCompleted) {
      this.isLoading = true;
      this.emit('onScrollTop', { context: this, completed: this.functions.onCompleted });
    }
  }

  scrollToBottom(smooth) {
    if (typeof this.el.scroll === 'function') {
      this.el.scroll({
        top: this.el.scrollHeight,
        behavior: smooth ? 'smooth' : 'instant',
      });
    } else {
      if (smooth && !this.el.style.scrollBehavior) this.el.style.scrollBehavior = 'smooth';
      else if (!smooth && this.el.style.scrollBehavior === 'smooth') this.el.style.scrollBehavior = '';
      this.el.scrollTop = this.el.scrollHeight;
    }
  }

  onCompleted() {
    this.isCompleted = true;
    // this.el.removeEventListener('scroll', this.functions.onScroll)
  }

  destroy() {
    this.observer.disconnect();
    this.el.removeEventListener('scroll', this.functions.onScroll);
  }

  emit(name, data) {
    const handlers = (this.vnode.data && this.vnode.data.on) || (this.vnode.componentOptions && this.vnode.componentOptions.listeners);
    if (handlers && handlers[name]) handlers[name].fns(data);
  }
}

let example = null;

export default {
  bind(el, value, vnode) {
    example = new ChatScroll(el, vnode);
    example.init();
  },
  unbind() {
    if (example) example.destroy();
    example = null;
  },
};
